import PropTypes from "prop-types";
import { LuCheck, LuEye, LuX } from "react-icons/lu";

export default function DocumentSentSuccessDialog({
  open,
  documentType,
  documentNumber,
  recipient,
  title,
  successMessage,
  onClose,
  onViewDetails,
}) {
  if (!open) return null;

  const label = documentType === "invoice" ? "Invoice" : "Quote";

  return (
    <div
      className="quotation-dialog-scrim"
      data-clickable="true"
      onClick={onClose}
    >
      <section
        className="quotation-send-dialog quotation-sent-success-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="document-sent-success-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="quotation-dialog-header">
          <h3 id="document-sent-success-title">{title || `${label} sent`}</h3>
          <button
            type="button"
            className="quotation-dialog-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <LuX />
          </button>
        </header>
        <div className="quotation-dialog-body quotation-send-success-panel">
          <span className="quotation-send-success-icon">
            <LuCheck aria-hidden="true" />
          </span>
          <h4>{successMessage || `${label} sent successfully`}</h4>
          <p>
            {documentNumber || label} was sent
            {recipient ? ` to ${recipient}` : ""}.
          </p>
          <button
            type="button"
            className="quotation-dialog-send-btn"
            onClick={onViewDetails}
          >
            <LuEye aria-hidden="true" /> View {label.toLowerCase()} details
          </button>
        </div>
      </section>
    </div>
  );
}

DocumentSentSuccessDialog.propTypes = {
  open: PropTypes.bool,
  documentType: PropTypes.oneOf(["quote", "invoice"]),
  documentNumber: PropTypes.string,
  recipient: PropTypes.string,
  title: PropTypes.string,
  successMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

DocumentSentSuccessDialog.defaultProps = {
  open: false,
  documentType: "quote",
  documentNumber: "",
  recipient: "",
};
